module.exports = __webpack_public_path__ + "img/reveles-logo-white.2ef58300.svg";